import { createIconComponent } from '../../factory/create-icon-component';
export const DoubleCheckIcon = createIconComponent(
  'DoubleCheckIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 12.4999L7 17.4999L12.5 11.9999L14.5 10L17.5 7"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.75 12.25L8 13.5M20.5 8.5L18 11L11.75 17.25L10 15.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
);
